<form class="move-folder" [formGroup]="form">
  <p [innerHTML]="'media.move_folder.description' | translate: {name:this.config.data.folder.name}"></p>
  <div class="input-row">
    <select class="primary" formControlName="destinationFolder" name="" id="">
      <option value="">{{'media.move_folder.please_select' | translate}}</option>
      <option value="0">{{'media.move_folder.root_directory' | translate}}</option>
      <ng-container *ngFor="let folder of (folders$ | ngrxPush)">
        <option value="{{ folder.id }}">{{ folder.name }}</option>
      </ng-container>
    </select>
    <ng-container *ngIf="form.controls.destinationFolder.invalid && (form.controls.destinationFolder.dirty || form.controls.destinationFolder.touched) && form.controls.destinationFolder.errors?.['required']">
      <div class="error">{{'media.move_folder.destination_folder_error' | translate}}</div>
    </ng-container>
  </div>
  <div class="btn-row">
    <p-button (click)="submit()" [label]="'media.move_folder.move' | translate" styleClass="p-button-primary"></p-button>
  </div>
</form>
